module.exports = __webpack_public_path__ + "img/2.a5b0c14e.svg";